// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"45db94d9","83":"0bd9f1af","94":"19c78990","210":"76c2aff3","459":"0f79fab4","522":"e61598de","855":"fe7714c1","920":"ed934e2d","999":"d1d5d692"}[chunkId] + ".chunk.js";
};